import { useContext } from "react"
import { cls, CustomContext, useSyncState } from "./Root"

import menu_star from 'images/menu_star.png'
import menu_triangle from 'images/menu_triangle.png'
import menu_triangle_expanded from 'images/menu_triangle_expanded.png'
import go_top from 'images/go_top_btn.png'

import { LuUnplug } from "react-icons/lu";

import { useRef } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom"

const HtmlIframe = ({ rawHtml }) => {
  const iframeRef = useRef(null);

  // Define the CSS styles to inject
  const customStyles = `
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      line-height: 1.4;
    }
  `;

  // Inject the styles into the rawHtml
  const injectStyles = (html) => {
    // Check if <head> exists, if not, create one
    const headRegex = /<head[^>]*>/i;
    if (headRegex.test(html)) {
      return html.replace(headRegex, `$&<style>${customStyles}</style>`);
    } else {
      // If no <head>, prepend <head> with styles
      return `<head><style>${customStyles}</style></head>${html}`;
    }
  };

  const styledHtml = injectStyles(rawHtml);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentDocument) {
      const getContentHeight = () => {
        const contentHeight = iframe.contentDocument.documentElement.scrollHeight + 5;
        iframe.style.height = `${contentHeight}px`;
      };

      iframe.addEventListener('load', getContentHeight);
      if (iframe.contentDocument.readyState === 'complete') {
        getContentHeight();
      }

      return () => iframe.removeEventListener('load', getContentHeight);
    }
  }, [styledHtml]);

  return (
    <iframe
      ref={iframeRef}
      title="HTML Content"
      srcDoc={styledHtml}
      scrolling="no"
      className="w-full"
      sandbox="allow-same-origin"
      // style={{transform: "scale(0.85)", transformOrigin: "top left", width: "117.64%", height: "117.64%"}}
    />
  );
};

const SectionBlock =({v, idx, expandedContext, customData})=>{
  const searchParams =useSearchParams()
  
  const htmlRef =useRef(null)
  return <div ref={htmlRef} className={cls('relative col-auto column')}>
    <button className="col-auto [&&]:h-[36px] MQ-PCP:[&&]:h-[40px] w-full bg-gradient-to-b from-[#85d8fa] to-[#54bbed] rounded-[20px] row items-center justify-between px-[15px]" onClick={(e)=>{
      if (expandedContext[2].current[customData.currCategory[0]+'_'+v.name+idx]===undefined){
        expandedContext[2].current[customData.currCategory[0]+'_'+v.name+idx] =false
      }
      expandedContext[2].current[customData.currCategory[0]+'_'+v.name+idx] =!expandedContext[2].current[customData.currCategory[0]+'_'+v.name+idx]
      expandedContext[1]({...expandedContext[2].current})
    }}>
      <div className="col row items-center">
        {searchParams[0].get('admin')==='1'&&v.public===false&&<span className="text-white text-[20px] pr-[5px]">
          <LuUnplug />
        </span>}
        <div className="col-auto"><img src={menu_star}/></div>
        <h2 className="col text-left truncate px-[15px] MQ-PCP:px-[20px] text-white font-bold text-[16px] MQ-PCP:text-[20px]">{v.name}</h2>
      </div>
      <div className="h-full min-w-[30px] MQ-PCP:w-[44px] row items-center justify-center">
        <img src={expandedContext[0][customData.currCategory[0]+'_'+v.name+idx]?menu_triangle_expanded:menu_triangle} className=""/>
      </div>
    </button>
    {expandedContext[0][customData.currCategory[0]+'_'+v.name+idx]&&<p className="relative col-auto bg-[#e5eaed] w-full rounded-[20px] my-[10px] pb-[40px]">
      <HtmlIframe rawHtml={v.html}/>
      <button className="absolute right-[10px] bottom-[10px]" onClick={(e)=>{
        htmlRef.current?.scrollIntoView({behavior: 'smooth', block: "start"})
      }}>
        <img src={go_top}/>
      </button>
    </p>}
  </div>
}


var Main =({})=>{
  const searchParams =useSearchParams()
  const expandedContext =useSyncState({})
  const customData =useContext(CustomContext)

  return <div data-allow-touch-move className="relative col-auto column px-[12px] MQ-PCP:px-[28px] py-[20px] space-y-[10px]">
    {
      (customData.currCategory[0]==='搜尋'?((customData.filteredManualData[0]&&searchParams[0].get('filter'))?customData.filteredManualData[0]:[{list:[]}]):customData.manualData[0]?.filter(v=>v.name===customData.currCategory[0])[0])?.list?.filter(v=>v.public||searchParams[0].get('admin')==='1')?.map((v,idx)=>{
        return <SectionBlock key={customData.currCategory[0]+'_'+v.name+idx} v={v} idx={idx} expandedContext={expandedContext} customData={customData}/>
      })
    }
  </div>
}

export default Main